import { render } from "./FormSearch.vue?vue&type=template&id=5f661f2a"
import script from "./FormSearch.vue?vue&type=script&lang=ts"
export * from "./FormSearch.vue?vue&type=script&lang=ts"
script.render = render

export default script